import React from "react";
import styles from "./grandTotal.scss";
import { getLoggedInUserInfo } from "../../../../common/utils/helper";
import { UserRoles } from "../../../../common/constant";
import NoTranslate from "../../../../common/components/notranslate/noTranslate";

const GrandTotal = ({ grandTotal, template }) => {
  if (!grandTotal) return
  const { totalPrice, totalPointVolume, totalBusinessVolume } = grandTotal;
  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  const LoggedInUserRole = getLoggedInUserInfo().role;
  const isABO = LoggedInUserRole === UserRoles.ABO;
  const totalTitle = template == "N+N+N" ? '總計(未折扣):' : '總計:'
  return (
    <div className={styles["total-container"]}>
      <div className={styles["price"]}>
        {totalTitle}{" "}
        <NoTranslate>
          $ {intlNumberFormatter.format(Number(totalPrice))}
        </NoTranslate>
      </div>
      {isABO && (
        <div className={styles["pv-bv-container"]}>
          <div className={styles["pv"]}>
            <span className={styles["content"]}>PV :</span>
            <span className={styles["value"]}>
              {intlNumberFormatter.format(Number(totalPointVolume))}
            </span>
          </div>

          <div className={styles["bv"]}>
            <span className={styles["content"]}>BV :</span>
            <span className={styles["value"]}>
              {intlNumberFormatter.format(Number(totalBusinessVolume))}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrandTotal;
